import { httpService, HttpResponse } from '../core/http'
import { PaginatedResponseData, PaginatedRequest } from '../core/interfaces'
import { BusinessUnit, City, CityFilter } from '../entities'
import { State } from '../entities/state'

export const getStates = async (): Promise<PaginatedResponseData<State>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/general/states',
      {
        params: {
          page: 1,
          limit: 29
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getCitites = async (
  query: PaginatedRequest<CityFilter>
): Promise<PaginatedResponseData<City>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/general/cities',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getBusinessUnits = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<BusinessUnit>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/general/business-units',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}
